import { render, staticRenderFns } from "./hospital-list.vue?vue&type=template&id=7c8a9dfc&"
import script from "./hospital-list.vue?vue&type=script&lang=ts&"
export * from "./hospital-list.vue?vue&type=script&lang=ts&"
import style0 from "./hospital-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports